import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Input from '../../Form/Field/Input.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'DoForm'

class DoForm extends Component {
  constructor(props) {
    super(props)
  }

  checkIfIsBusinessManager = () =>{
    if(this.props && this.props.initialValues && this.props.initialValues.isBusinessManager) {
      return this.props.initialValues.isBusinessManager
    }
    return false
  }

  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>

          <div className="row">
            <div className="col-md-6">
              <Field
                label="Prénom"
                name="firstname"
                placeholder="John..."
                type="text"
                component={Input} />
            </div>
            <div className="col-md-6">
              <Field
                label="Nom"
                name="lastname"
                placeholder="Doe..."
                type="text"
                component={Input} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Numéro de téléphone"
                name="tel"
                placeholder="06 10 11 12 21"
                type="text"
                component={Input} />
            </div>
            {this.checkIfIsBusinessManager() && (
              <div className="col-md-6">
                <Field
                  label="RDV consultant - URL calendly"
                  name="calendly_url"
                  placeholder=""
                  type="text"
                  component={Input} />
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Nom de votre entreprise"
                name="organization.name"
                type="text"
                maxLength={45}
                component={Input} />
            </div>
            <div className="col-md-6">
              <Field
                label="Fonction"
                name="fonction"
                type="text"
                component={Input} />
            </div>
          </div>
          {this.checkIfIsBusinessManager() && (
            <div className="row">
              <div className="col-md-12">
                <Field
                  label="Présentation de mon parcours"
                  name="description"
                  type="textarea"
                  maxLength={600}
                  component={Input} />
              </div>
            </div>
          )}
          <input className="d-none" type="submit" />
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(DoForm)
